(ns machtfit.widgets.switch)

(defn switch [{:keys [label external-label-id help-text checked? on-click]}]
  [:<>
   [:button {:role "switch"
             :type "button"
             :on-click on-click
             :aria-checked checked?
             :aria-labelledby external-label-id
             :class [(if checked?
                       "bg-brand-500"
                       "bg-gray-100")
                     "relative"
                     "inline-flex"
                     "h-6"
                     "w-11"
                     "shrink-0"
                     "cursor-pointer"
                     "rounded-full"
                     "border-2"
                     "border-transparent"
                     "transition-colors"
                     "duration-200"
                     "ease-in-out"
                     "focus:outline-none"
                     "focus-visible:ring-2"
                     "focus-visible:ring-white/75"]}
    [:span {:aria-hidden "true"
            :class [(if checked?
                      "translate-x-5"
                      "translate-x-0")
                    "pointer-events-none"
                    "inline-block"
                    "h-5"
                    "w-5"
                    "transform"
                    "rounded-full"
                    "bg-white"
                    "shadow-lg"
                    "ring-0"
                    "transition"
                    "duration-200"
                    "ease-in-out"]}]]
   (when (or label help-text)
     [:div.flex.flex-col
      (when label
        [:strong.text-base.text-gray-800 label])
      (when help-text
        [:span.text-base.text-gray-800 help-text])])])
